import { createAction, props } from '@ngrx/store';
import { Params } from '@angular/router';

export namespace RouterActions {
  export const navigate = createAction(
    '[ROUTER] navigate',
    props<{ url: string; queryParams?: Params; fragment?: string }>()
  );
}
